<template>
  <div>
    <div class="border-0 border-b border-solid border-gray-a10 py-5 flex justify-center h-18 items-center">
      <h3 class="font-bold flex justify-center text-lg text-black-soft">
        Assistance Resolution

        <vs-tooltip class="flex ml-1 items-center" position="bottom">
          <template #content>
            <div v-html="hint"/>
          </template>

          <vs-icon icon="info" class="text-gray cursor-default"/>
        </vs-tooltip>
      </h3>
    </div>
    <pie-chart :aggregate-request-outcomes="sortedOutcomes"
               :total="assistanceTypeTotal"
               :title="`${formatDate(dateFrom)} - ${formatDate(dateTo)}`"
               :default-chart-data="[]"
               id="assistance-type-chart"
               class="min-w-64 pt-8"
               :chart-height="275"
               :is-loading="false"
    />
  </div>
</template>

<script>
import PieChart from '@/components/analytics/charts/PieChart'
import CardWrapper from '@/components/base-components/CardWrapper'
import analyticsFilterModule from '@/store/modules/analytics-filter.module'
import { GRANULARITY_REQUEST } from '@/utils/filter.constants'
import { CHART_TEXT } from '@/utils/text.constants'
import requestOutcomeMapper from '@/utils/request-outcome.mapper'
import datetimeUtils from '@/utils/datetime.utils'
import analyticsModule from '@/store/modules/analytics.module'

export default {
  name: 'AssistanceTypePieChart',

  components: {
    PieChart,
    CardWrapper
  },

  data() {
    return {
      aggregatedAssistanceTypeOutcomes: []
    }
  },

  computed: {
    granularity: analyticsFilterModule.getGranularity,
    dateFrom: analyticsFilterModule.getDateFrom,
    dateTo: analyticsFilterModule.getDateTo,
    bot: analyticsFilterModule.getBot,
    channels: analyticsFilterModule.getChannels,
    requestTotal: analyticsModule.getRequestTotal,
    requests: analyticsModule.getRequests,

    hint() {
      const {
        REQUEST_ASSISTANCE_TYPE_HINT,
        CONTACT_ASSISTANCE_TYPE_HINT,
        REQUEST_HINT,
        CONTACT_HINT
      } = CHART_TEXT
      return GRANULARITY_REQUEST === this.granularity ?
        `${REQUEST_ASSISTANCE_TYPE_HINT}${REQUEST_HINT}` :
        `${CONTACT_ASSISTANCE_TYPE_HINT}${CONTACT_HINT}`
    },

    contacts() {
      return requestOutcomeMapper.mapContactOutcomes(this.requests, 'resolution')
    },

    assistanceTypeTotal() {
      return GRANULARITY_REQUEST === this.granularity ?
        this.requests.length :
        this.contacts.length
    },

    sortedOutcomes() {
      if (GRANULARITY_REQUEST === this.granularity) {
        const assistanceTypeData = requestOutcomeMapper.mapAssistanceTypeData(this.requests)
        return requestOutcomeMapper.sortOutcomes(assistanceTypeData)
      } else {
        const assistanceTypeData = requestOutcomeMapper.mapAssistanceTypeData(this.contacts)
        return requestOutcomeMapper.sortOutcomes(assistanceTypeData)
      }
    }
  },

  methods: {
    formatDate(dateString) {
      return datetimeUtils.toMoment(dateString).format('D MMM, YY')
    }
  }
}
</script>
